<template>
  <!-- 线上 -->
  <Modal v-model="visible" width="1200" :title="isIFA ? '佣金记录' : '积分台账'" class="my-modal" :footer-hide="true">
    <div class="tools-box">
      <Button type="primary" @click="refresh">重新生成佣金</Button>
    </div>
    <div class="table-box">
      <loading :isShow="loading" />
      <Table :columns="columns" max-height="500" :data="commissionList" :row-class-name="setRowClassName"> </Table>
    </div>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </Modal>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import vipLevelMixin from '@/api/vipLevelMixin';
import { common } from '@/api/mixins';
import confirmModal from '@/components/commons/confirmModal';
export default {
  mixins: [vipLevelMixin, common],
  props: [],
  components: { lzDicTxt, confirmModal },
  data() {
    return {
      userInfo: {},
      loading: false,
      commissionList: [],
      visible: false,
      baseData: {},
      code: '',
      id: ''
    };
  },
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    },
    columns() {
      if (this.userInfo.merchantType == 3) {
        return [
          {
            title: '第几年积分',
            key: 'commissionIndex',
            width: 120,
            align: 'center'
          },
          {
            title: '次数',
            key: 'currCount',
            width: 120,
            align: 'center'
          },
          {
            title: '险种名称',
            key: 'riskName',
            minWidth: 150,
            align: 'center',
            render(h, params) {
              const value = params.row.riskName || '-';
              return <span>{value}</span>;
            }
          },
          {
            title: '积分所属转介人',
            key: 'owerName',
            minWidth: 150,
            align: 'center'
          },
          {
            title: `${this.code == 'IFA' ? '保单销售积分比例' : '保单净积分比例'}`,
            key: 'netCommissionRate',
            minWidth: 120,
            align: 'center',
            render(h, params) {
              const value = params.row.netCommissionRate || '0';
              return <span>{value}%</span>;
            }
          },
          {
            title: `${this.code == 'IFA' ? '保单销售积分' : '保单净积分'}`,
            key: 'netCommission',
            minWidth: 120,
            align: 'center',
            render(h, params) {
              const value = params.row.netCommission || '-';
              return <span>{value}</span>;
            }
          }
        ];
      } else {
        return [
          {
            title: '第几年积分',
            key: 'commissionIndex',
            width: 120,
            align: 'center'
          },
          {
            title: '次数',
            key: 'currCount',
            width: 120,
            align: 'center'
          },
          {
            title: '险种名称',
            key: 'riskName',
            minWidth: 150,
            align: 'center',
            render(h, params) {
              const value = params.row.riskName || '-';
              return <span>{value}</span>;
            }
          },
          {
            title: `${this.code == 'IFA' ? '保单销售积分比例' : '保单净积分比例'}`,
            key: 'netCommissionRate',
            minWidth: 120,
            align: 'center',
            render(h, params) {
              const value = params.row.netCommissionRate || '0';
              return <span>{value}%</span>;
            }
          },
          {
            title: `${this.code == 'IFA' ? '保单销售积分' : '保单净积分'}`,
            key: 'netCommission',
            minWidth: 120,
            align: 'center',
            render(h, params) {
              const value = params.row.netCommission || '-';
              return <span>{value}</span>;
            }
          }
        ];
      }
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.setVipLevelList();
  },
  methods: {
    // 删除
    refresh() {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '是否重新生成佣金?'
        })
        .then(() => {
          this.$http({
            url: '/buz/policy/rebuildIfaCommissionLog',
            type: 'GET',
            data: {
              policyId: this.id
            }
          }).then(res => {
            this.$notice.msg('操作成功');
            this.getDetailData(this.id);
          });
        });
    },
    // 打开弹窗
    open({ id, code }) {
      this.code = code;
      this.id = id;
      if (id) this.getDetailData(id);
    },
    // 获取保单详情
    getDetailData(id) {
      this.loading = true;
      this.$http({
        url: '/buz/policy/queryPointsLog',
        type: 'GET',
        data: {
          id
        }
      })
        .then(res => {
          this.baseData = res.data;
          this.commissionList = res.data.pointsLogList || [];
          this.visible = true;
        })
        .finally(res => {
          this.loading = false;
          // this.$notice.hideLoading();
        });
    },
    setRowClassName(row) {
      if (row.netCommission < 0 || row.netCommissionAmount < 0) {
        return 'red-row';
      }
      return '';
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  padding: 10px 0;
}
/deep/ .red-row td {
  color: red;
}
.tools-box {
  justify-content: flex-end;
  margin-bottom: 0;
  margin-top: 10px;
}
</style>
